module.exports = __webpack_public_path__ + "img/logo2.def38e13.png";